const volunteer = () => import('../views/reviewers-menu/volunteer')
const reviews = () => import('../views/reviewers-menu/reviews')
const reviewsAgreed = () =>
  import('../views/reviewers-menu/reviews/agreed-review')
const reviewsConfirm = () =>
  import('../views/reviewers-menu/reviews/confirm-review')
const reviewsRefuse = () =>
  import('../views/reviewers-menu/reviews/refuse-review')
const reviewsDetail = () =>
  import('../views/reviewers-menu/reviews/review-detail')
const path = '/reviewers-menu'

export default [
  {
    path: path + '/volunteer',
    component: volunteer,
    name: '/reviewers-menu/volunteer'
  },
  {
    path: path + '/reviews',
    component: reviews,
    name: '/reviewers-menu/reviews'
  },

  {
    path: path + '/reviews/reviews-agree',
    component: reviewsAgreed,
    name: '/reviewers-menu/reviews/reviews-agree'
  },
  {
    path: path + '/reviews/reviews-refuse',
    component: reviewsRefuse,
    name: '/reviewers-menu/reviews/reviews-refuse'
  },
  {
    path: path + '/reviews/reviews-confirm',
    component: reviewsConfirm,
    name: '/reviewers-menu/reviews/reviews-confirm'
  },
  // 查看历史报告(审稿人列表)
  {
    path: path + '/reviews/review-detail/:id',
    component: reviewsDetail,
    name: '/reviewers-menu/reviews/review-detail'
  }
]
